module.exports = __webpack_public_path__ + "img/charts2.0397685d.jpg";